import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/back-arrow.png'


const _hoisted_1 = { class: "detail-component" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "返回",
          class: "back-icon"
        }, null, -1)
      ])),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.detail.title), 1)
    ]),
    _createElementVNode("img", {
      src: _ctx.detail.image,
      alt: "图片",
      class: "detail-image"
    }, null, 8, _hoisted_4),
    _createElementVNode("p", null, "价格：" + _toDisplayString(_ctx.detail.price), 1),
    _createElementVNode("p", null, "标签：" + _toDisplayString(_ctx.detail.tags.join(', ')), 1)
  ]))
}